import React from 'react';
import { interpolateRatingColor } from '../hooks/useCoffeeShops';

interface RatingBadgeProps {
    rating: number;
    size?: 'sm' | 'md' | 'lg';
    showMax?: boolean;
    className?: string;
}

const RatingBadge: React.FC<RatingBadgeProps> = ({
    rating,
    size = 'md',
    showMax = true,
    className = ''
}) => {
    const color = interpolateRatingColor(rating);

    const sizeClasses = {
        sm: 'px-2 py-1 text-sm',
        md: 'px-3 py-1.5 text-base',
        lg: 'px-4 py-2 text-xl'
    };

    const ratingClasses = {
        sm: 'text-sm font-bold',
        md: 'text-lg font-bold',
        lg: 'text-2xl font-extrabold'
    };

    const maxClasses = {
        sm: 'text-xs',
        md: 'text-sm',
        lg: 'text-base'
    };

    return (
        <div
            className={`inline-flex items-baseline rounded-lg border backdrop-blur-sm ${sizeClasses[size]} ${className}`}
            style={{
                backgroundColor: `${color}25`,
                borderColor: `${color}50`
            }}
        >
            <span className={ratingClasses[size]} style={{ color }}>
                {rating.toFixed(1)}
            </span>
            {showMax && (
                <span className={`${maxClasses[size]} ml-0.5 opacity-60`} style={{ color }}>
                    /10
                </span>
            )}
        </div>
    );
};

export default RatingBadge;
